module.exports = __webpack_public_path__ + "static/media/churchpin.87729925.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/churchpin.svg
// module id = 699
// module chunks = 0